/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import BusinessView from './component/business'
import { Spin } from 'antd'

class Business extends React.Component {
  static defaultProps = {
    paymentList: [],
    period: {
      start_time: null,
      end_time: null,
    },
    business: [],
    recordDetail: {
      list: [],
      goodsList: [],
    },
  }

  componentWillUnmount() {
    this.props.getPeriod({ start_time: null, end_time: null }) //清除
    this.props.getBusiness([]) //清除
    this.props.getPaymentList([])
  }

  render() {
    const { paymentList, period, business, recordDetail, clubList } = this.props

    return (
      <BusinessView
        paymentList={paymentList}
        period={period}
        business={business}
        clubList={clubList}
        recordDetail={recordDetail}
        fetchPaymentList={this.props.fetchPaymentList}
        fetchIncomeBusiness={this.props.fetchIncomeBusiness}
        getPeriod={this.props.getPeriod}
        fetchTimePeriod={this.props.fetchTimePeriod}
        fetchRecordDetails={this.props.fetchRecordDetails}
        fetchSnDetails={this.props.fetchSnDetails}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    paymentList: state.getConsume.paymentList,
    period: state.getConsume.period,
    business: state.getConsume.business,
    recordDetail: state.getConsume.recordDetail,
    clubList: state.getHome.clubList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(Business))



// WEBPACK FOOTER //
// ./src/containers/Consume/index.js